// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"RunsTable_checkbox__1BRG9","checkedCheckbox":"RunsTable_checkedCheckbox__35Mcl","sortingBox":"RunsTable_sortingBox__3qjO5"};